<template>
  <v-dialog v-model="dialog" :key="pb.id" max-width="900" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-avatar>
          <v-icon>{{ pb.icone }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ pb.descricao }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold green lighten-4">{{
        pb.descricao
      }}</v-card-title>
      <v-card-text class="pt-3">
        <template v-if="pb.tipo_arquivo == 'img'">
          <v-img :src="pb.url" contain></v-img>
        </template>
        <template v-if="pb.tipo_arquivo == 'pdf'">
          <vue-pdf-embed :source="pb.url"></vue-pdf-embed>
        </template>
      </v-card-text>
      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" depressed dark rounded block
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
export default {
  props: {
    pb: Object,
  },
  components: {
    VuePdfEmbed,
  },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>
